import React, { useState } from "react";
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import "../App.css";

import { AppBar, Button, Chip, IconButton, Menu, MenuItem, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import TARAHeader from "../data/tara-header-navbar.png";
import ChangeLang from "./ChangeLang";

const Navbar = ({signOut, user, header}) => {
  const [chartWidth, setChartWidth] = useState(0)
  const [anchorElNav, setAnchorElNav] = useState(null);

  const { t } = useTranslation();

  const handleSiderbarDisplayClick = (e) => {
    const sidebarElement = ReactDOM.findDOMNode(document.querySelector(".mainContent .sidebarContent"))
    const chartsElement = ReactDOM.findDOMNode(document.querySelector(".mainContent .charts"))
    if(window.screen.width>1100 && chartsElement && !chartWidth) setChartWidth(chartsElement.clientWidth)

    if(sidebarElement.style.display === "none"){
      if(window.screen.width>1100 && chartsElement) chartsElement.style.width = chartWidth+"px"
      sidebarElement.style.display = "flex"
    }
    else{
      if(window.screen.width>1100 && chartsElement) chartsElement.style.width = "unset"
      sidebarElement.style.display = "none"
    } 
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar color="inherit" position="static" className="navbar">
      <Toolbar>
        {user ? 
          <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={handleSiderbarDisplayClick}
          >
            <MenuIcon />
          </IconButton>
          :
            <div className="signedOutNavMenuDiv">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="home-menu"
                onClick={handleOpenNavMenu}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                className="signedOutNavMenu"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
              >
                <MenuItem onClick={handleCloseNavMenu}>
                  <Button color="inherit" sx={{textTransform: "unset", justifyContent: "start"}} to="/" component={Link}>
                    {t("signedOutUser.navbar.linkButtons_login")}
                  </Button>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                  <Button color="inherit" sx={{textTransform: "unset", justifyContent: "start"}} to="/privacy-policy" component={Link}>
                    {t("signedOutUser.navbar.linkButtons_privacyPolicy")}
                  </Button>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                  <Button color="inherit" sx={{textTransform: "unset", justifyContent: "start"}} to="/contact-us" component={Link}>
                    {t("signedOutUser.navbar.linkButtons_contactUs")}
                  </Button>
                </MenuItem>
              </Menu>
            </div>
        }
        <div className="navHeader">
          <IconButton component={Link} to="/" disableFocusRipple disableRipple sx={{padding: 0}}>
            <img alt="TARA-Header" src={TARAHeader}/>
          </IconButton>
        </div>
        {user 
          ?
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", flexGrow: 1, gap: "0.5rem" }}>
              <Chip color="info" label={t("commonComponents.navbar.greeting", { email: user.attributes.email })} variant="outlined" sx={{"& .MuiChip-label": {"padding": 0}}}/>
              <ChangeLang/>
              <Button onClick={signOut} color="info" variant="contained">
                {t("commonComponents.navbar.signOutButton")}
              </Button>
            </div>
          :
            <div style={{paddingLeft: "1rem", display: "flex", justifyContent: "space-between", alignItems: "center", flexGrow: 1}}>
              <h3>{header}</h3>
              <div style={{display: "flex", alignItems: "center"}}>
                <div className="signedOutNav">
                  <Button color="info" sx={{mr: 1, textTransform: "unset"}} to="/" component={Link} onClick={handleCloseNavMenu}>
                    {t("signedOutUser.navbar.linkButtons_login")}
                  </Button>
                  <Button color="info" sx={{mr: 1, textTransform: "unset"}} to="/privacy-policy" component={Link} onClick={handleCloseNavMenu}>
                    {t("signedOutUser.navbar.linkButtons_privacyPolicy")}
                  </Button>
                  <Button sx={{mr: 1, textTransform: "unset"}} color="info" to="/contact-us" component={Link} onClick={handleCloseNavMenu}>
                    {t("signedOutUser.navbar.linkButtons_contactUs")}
                  </Button>
                </div>
                <ChangeLang/>
              </div>
            </div>
        }
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
